module.exports = __webpack_public_path__ + "static/media/los angelos.ec68ef4a.png";